import { useMutation } from '@tanstack/react-query';
import { finishRevision } from '../queries/post';

export function useFinishPracticeRevision() {
  const { mutate, data, isPending, isSuccess } = useMutation({
    mutationKey: ['finishPracticeRevision'], 
    mutationFn: (id: string) => finishRevision(id),
    retry: false
  });

  return { mutate, data, isPending, isSuccess };
}
